import { InjectionToken } from '@angular/core';

export const ENV_OPTIONS = new InjectionToken<any>('ENV_OPTIONS');
